import axios from "axios";
import { building, JSON_URL } from "../../api";

const apiUrl = building;

export function loadBuildingJson() {
  return axios.get(
    `${JSON_URL}register.register_building/items.json?limit=50000`
  );
}

export function loadSpecificBuildingJson(id) {
  return axios.get(
    `${JSON_URL}register.register_building/items.json?limit=50000&boundary_id_id=${id}`
  );
}

export function loadCategoryBuildingJson(id) {
  return axios.get(
    `${JSON_URL}register.register_building/items.json?limit=50000&dictionary_building_category_id=${id}`
  );
}

export function loadBuilding(pageLimit, page, search, boundary, zone) {
  // boundary = any boundary id (Island/Region/District/Shehia) -> filters by
  // its whole sub-tree; zone = exact zone id. Both optional.
  const params = [`limit=${pageLimit}`, `offset=${page}`, `search=${search || ''}`];
  if (boundary) params.push(`boundary=${boundary}`);
  if (zone) params.push(`zone=${zone}`);
  return axios.get(`${apiUrl}/building/filter?${params.join('&')}`);
}

export function loadBuildingDashboard(pageLimit, page, category, search) {
  return axios.get(
    `${apiUrl}/building/filter?limit=${pageLimit}&offset=${page}&dictionary_building_category__dictionary_item_name_en=${category}&search=${search}`
  );
}

export function loadBuildingDetail(id) {
  return axios.get(`${apiUrl}/building/details/${id}`);
}

export function loadOneBuildingMap(id) {
  return axios.get(`${apiUrl}/building/map/${id}`);
}

export function loadBuildingUpdate(id) {
  return axios.get(`${apiUrl}/building/update/${id}`);
}

export function updateBuilding(id, data) {
  return axios.put(`${apiUrl}/building/update/${id}`, data);
}

export function loadBuildingCount(id, number) {
  return axios.get(`${apiUrl}/building/count/${id}/${number}`);
}

export function loadBuildingCountAll(category) {
  return axios.get(`${apiUrl}/building/count/all/${category}`);
}

export function loadBuildingCountTotal() {
  return axios.get(`${apiUrl}/building/count/total`);
}

export function loadBuildingMembersCount(boundaryId) {
  const q = boundaryId ? `?boundary_id=${boundaryId}` : "";
  return axios.get(`${apiUrl}/building/members_count${q}`);
}

export function loadBuildingAutoComplete(pageLimit, page, search) {
  return axios.get(
    `${apiUrl}/building/filter?limit=${pageLimit}&offset=${page}&search=${search}`
  );
}

export function addBuilding(data) {
  return axios.post(`${apiUrl}/building/create`, data);
}

export function uploadBuilding(formData) {
  return axios.post(`${apiUrl}/building/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
